import {  ProductFeature } from '@/domain/products/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Accordion, AccordionDetails, AccordionSummary } from '@andritzot/metris-web-ui/surfaces/accordion';

interface FeatureContentProps {
  productFeature: ProductFeature[];
}

const readonlySxStyle = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': { border: 'none' },
    '&:hover fieldset': { border: 'none' },
    '&.Mui-focused fieldset': { border: 'none' },
  },
};

export const FeatureContent = ({ productFeature }: FeatureContentProps) => {
  const sortedFeature = [...productFeature].sort((a, b) => a.order - b.order);

  return (
    <Box sx={{ backgroundColor: '#fff' }}>
      {sortedFeature.map((feature) => (
        <Accordion
          key={feature.id}
          defaultExpanded={false}
          disableGutters
          slotProps={{ transition: { unmountOnExit: true } }}
        >
          <AccordionSummary sx={{ backgroundColor: '#fff', boxShadow: 'none', border: 'none' }}>
            <Typography sx={{ mr: 4 }}>#{feature.order}</Typography>
            <Typography>{feature.title}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: '#fff' }}>
            <TextField
              label="Description"
              value={feature.description}
              multiline
              fullWidth
              slotProps={{ htmlInput: { readOnly: true } }}
              sx={readonlySxStyle}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};
